export default {
  init($element) {

  },
  finalize($element) {

    var zoomAmount = 1.5;
    var desiredWidth = 850;

    $element.find('.zoom').each(function() {

      // Clone the image wrap
      const $zoomWrap = $(this).children().clone().appendTo($(this));
      $zoomWrap.addClass('zoom-wrap');

      $(this).on('mouseenter', function() {
        $(this).addClass('zooming');
        $(this).parents('.home-image-masonry').addClass('zooming');

        var targetWidth = desiredWidth;

        if (desiredWidth >= $(window).width() - 30) {
          targetWidth = $(window).width() - 30;
        }

        zoomAmount = (targetWidth / $(this).width());

        const wrapX = $zoomWrap.offset().left;
        const wrapW = $zoomWrap.width();

        // Check if zooming the image this amount pushes it out of the container, if so change zoom direction
        var origin = 'center 0';

        if (wrapX - (wrapW * (zoomAmount - 1) * 0.5) <= 30) origin = '0 0';
        if (wrapX + wrapW + (wrapW * (zoomAmount - 1) * 0.5) >= $(window).width() - 30) origin = '100% 0';

        $zoomWrap.css({
          transform: `scale(${zoomAmount})`,
          transformOrigin: origin,
        });
      });

      $(this).on('mouseleave', function() {
        $(this).removeClass('zooming');
        $(this).parents('.home-image-masonry').removeClass('zooming');

        $zoomWrap.css({
          transform: 'scale(1)',
        });
      });

    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/imageMasonry.js